import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { GoogleLogin } from '@react-oauth/google'
import { CustomButton } from 'components'
import { googleAuth } from 'modules/session/session-actions'
import { goAfterSignIn, isSessionCookiesEnabled, isExternalRedirect } from 'utils/sessionSharing'
import googleIcon from 'images/google-icon.svg'
import './index.styl'

const GOOGLE_AUTH_ENABLED = true

const GoogleAuthButton = ({ redirectTo = '/home', onAuthSuccess }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()

  const onSuccess = credentialResponse => {
    setLoading(true)
    dispatch(googleAuth(credentialResponse.credential))
      .then(user => {
        setLoading(false)
        if (onAuthSuccess) {
          onAuthSuccess(user)
        } else if (user?.mobile) {
          goAfterSignIn(history, redirectTo)
        } else {
          history.push(`/auth/complete-account?redirectTo=${encodeURIComponent(redirectTo)}`)
        }
      })
      .catch(() => setLoading(false))
  }

  if (!GOOGLE_AUTH_ENABLED) return null
  // Google sign-in does not set the shared session cookie until SOU-2.6, so do not offer it for a Sou-Sou hand-off
  if (isSessionCookiesEnabled() && isExternalRedirect(redirectTo)) return null

  return (
    <div className='wrapperGoogleAuthButton'>
      <div className='divider'>
        <div className='line' />
        <div className='dividerText'>or</div>
        <div className='line' />
      </div>
      {/* Google's button is rendered invisibly on top of our styled button so the click lands
          on the real GSI element (needed for a genuine user gesture) while users see our design. */}
      <div className='googleButtonOverlay'>
        <CustomButton
          text='Continue with Google'
          type='white'
          className='googleButton'
          htmlType='button'
          loading={loading}
          icon={<img src={googleIcon} alt='' className='googleIcon' />}
        />
        <div className='googleLoginOverlay'>
          <GoogleLogin
            onSuccess={onSuccess}
            onError={() => setLoading(false)}
            width='318'
            size='large'
            shape='rectangular'
            text='continue_with'
          />
        </div>
      </div>
    </div>
  )
}

export default GoogleAuthButton
